import {useContext} from 'react'

import Context from '@s-ui/react-context'
import {useRouter} from '@s-ui/react-router'
import ModalTransactionDiscover from '@adv-mt/mt-modal-transaction-discover'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import {ROUTES} from '../../../../../config/index.js'
import {useMessagingContext} from '../../useMessagingContext/index.js'

export const ModalTransactionAccept = () => {
  const {domain} = useContext(Context)
  const config = domain.get('config')

  const {track} = useAnalyticsTrack()

  const {TRACKING_EVENT_NAMES} = config.get('tracking')

  const {push} = useRouter()
  const {state, setInteractionComponent} = useMessagingContext()
  const {interactionUrl} = state
  const {searchParams} = new URL(interactionUrl)
  const tradeId = searchParams.get('tradeId')
  const adId = searchParams.get('adId')

  domain
    .get('get_event_tracking_data_use_case')
    .execute({
      ad: {id: adId},
      event: TRACKING_EVENT_NAMES.SELLER_PAYCAR_START_CLICKED_TRANSACTION
    })
    .then(eventTrackingData => track(eventTrackingData))

  const trackRequestAccepted = () => {
    domain
      .get('get_event_tracking_data_use_case')
      .execute({
        ad: {id: adId},
        event: TRACKING_EVENT_NAMES.SELLER_PAYCAR_SAFE_PURCHASE_CLICKED_TRANSACTION
      })
      .then(eventTrackingData => track(eventTrackingData))
  }

  const trackRequestRejected = () => {
    domain
      .get('get_event_tracking_data_use_case')
      .execute({
        ad: {id: adId},
        event: TRACKING_EVENT_NAMES.SELLER_PAYCAR_SAFE_PURCHASE_REFUSED_TRANSACTION
      })
      .then(eventTrackingData => track(eventTrackingData))
  }

  return (
    <ModalTransactionDiscover
      onModalClose={() => setInteractionComponent({component: null, show: false})}
      onModalRejectRequestCtaClick={() => {
        trackRequestRejected()
        setInteractionComponent({component: null, show: false})
      }}
      onCtaClick={() => {
        trackRequestAccepted()
        push(`${ROUTES.TRANSACTION.TERMS}?tradeId=${tradeId}&adId=${adId}`)
      }}
      isSeller={true}
      tradeId={tradeId}
    />
  )
}
